import React from "react";
import Link from "../base/Link";
import API from "../base/API";
import EditButton from "../base/EditButton";
import Storage from "../base/Storage";
import { hasPermission } from "../auth/Auth";
import { translate } from "../base/Translation";

export default class TestsWidget extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            get_tests: "/test/list?limit_from=:from&limit_max=:to&brand=:brand"
        });

        this.state = {
            tests: [],
            title: translate("Posledné testy"),
            viewAllButtonText: translate("Zobraziť všetky"),
            loading: false,
            interval: null,
            limit_from: 0,
            limit_to: 5
        }
    }

    fetchData() {
        this.setState({ loading: true });
        let brandFilter = Storage.get("brand_filter");

        this.api.request({
            route: "get_tests",
            params: { from: this.state.limit_from, to: this.state.limit_to, brand: (brandFilter ? brandFilter.id : "all") },
            success: (response) => {
                this.setState({ tests: response, loading: false });
            }
        });
    }

    componentDidMount() {
        this.fetchData();

        /*let interval = setInterval(function () {
            this.fetchData();
        }.bind(this), 2000);

        this.setState({ interval: interval });*/
    }

    componentWillUnmount() {
        clearInterval(this.state.interval);
    }

    createTestList() {
        return this.state.tests.map(function (test) {
            return (
                <div key={test.name} className="list-group-item">
                    <Link to={"/tests/" + test.id}>{test.name}</Link>
                    <div className="pull-right">
                        <EditButton to={"/tests/edit/" + test.id} permission={hasPermission("TestEdit", test)} />
                    </div>
                </div>
            )
        });
    }

    render() {
        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">
                        <i className="fa fa-file-text fa-fw">&nbsp;</i> {this.state.title}
                        <span className="pull-right loading-small">{this.state.loading ? translate("Načítavam...") : ""}</span>
                    </h3>
                </div>
                <div className="panel-body">
                    <div className="list-group">
                        {this.createTestList()}
                    </div>
                    <div className="text-right">
                        <Link to="/tests">{this.state.viewAllButtonText}&nbsp;
                                <i className="fa fa-arrow-circle-right">&nbsp;</i>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/TestsWidget.js